/// <reference path="../../../../../rcwebmodels/rcdstatus.cs.d.ts" />
import * as React from 'react';
import { RCUtils } from './../../RCUtils';
import $ from 'jquery';
import * as Autosuggest from 'react-autosuggest';
import queryString from 'query-string';
import { isNullOrUndefined } from 'util';
import { PopupWindow } from '../sharedcomponents/PopupWindow';

var Config: any = require('../../Config.json');
var skip = false;
var self;
interface SearchState {
    RcdCountry: server.RCDCountryModel[],
    Filters: server.RcdStatusSearchFilters,
    AssetTypes:server.AssetTypes[],
    RcdGeofences: string[],
    suggestionsFenceId: any[],
    targetId: string
}

export class RcdAdvanceSearch extends React.Component<any, SearchState> {
    constructor(props: any) {
        super(props);
        var filter: server.RcdStatusSearchFilters = {
            SelectedRcd: null, SelectedCountry: null, SelectedInterval: null, SelectedGeofenceInside: null, SelectedGeofence: '', SelectedICCID: null, SelectedMSISDN:null, AllRcds: null,SelectedAssetType:null
        };

        if (this.props.stateData != null && this.props.stateData != undefined && this.props.stateData != null) {
            //filter = this.props.stateData;
            filter.SelectedRcd = this.props.stateData.SelectedRcd == null ? '' : this.props.stateData.SelectedRcd;
            filter.SelectedCountry = this.props.stateData.SelectedCountry == null ? '' : this.props.stateData.SelectedCountry;
            filter.SelectedInterval = this.props.stateData.SelectedInterval == null ? '' : this.props.stateData.SelectedInterval;
            filter.SelectedGeofenceInside = this.props.stateData.SelectedGeofenceInside == null ? '' : this.props.stateData.SelectedGeofenceInside;
            filter.SelectedGeofence = this.props.stateData.SelectedGeofence == null ? '' : this.props.stateData.SelectedGeofence;
            filter.SelectedICCID = this.props.stateData.SelectedICCID == null ? '' : this.props.stateData.SelectedICCID;
            filter.SelectedMSISDN = this.props.stateData.SelectedMSISDN == null ? '' : this.props.stateData.SelectedMSISDN;
            filter.AllRcds = this.props.stateData.AllRcds == null ? '' : this.props.stateData.AllRcds;
            filter.SelectedAssetType = this.props.stateData.SelectedAssetType == null ? '' : this.props.stateData.SelectedAssetType;
        }

        this.state = {
            RcdCountry: [], Filters: filter, AssetTypes: [], RcdGeofences: [], suggestionsFenceId: [],
            targetId: '',
        };

        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/common/GetGeofences')
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.GeofenceList[]>)
            .then(data => {
                if (data.length > 0) {
                    var fenceData = data.map(fence => fence.Tag);
                    this.setState({ RcdGeofences: fenceData });
                }
            });

        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/common/RefCountry')
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.RCDCountryModel[]>)
            .then(data => {
                this.setState({ RcdCountry: data });
            });
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/RcdStatus/GetAssetTypes')
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.AssetTypes[]>)
            .then(data => {
                this.setState({ AssetTypes: data });
            });

        self = this;
    }

    RCDIDschange(event: React.FormEvent<HTMLTextAreaElement>) {
        var filters = this.state.Filters;
        //$('#txtRcdId').val(this.GetMultiLineCsv($('#txtRcdIds').val()));
        filters.SelectedRcd = this.GetMultiLineCsv($('#txtRcdIds').val());//$('#txtRcdId').val().toString();
        this.setState({
            Filters: filters
        });
    }


    RCDchange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.Filters;
        var Value: string = event.currentTarget.value;
        filters.SelectedRcd = Value;
        this.setState({
            Filters: filters
        });
        if (!skip)//-->checking closing window 
        {
            $('#txtRcdIds').val(this.GetMultiLineCsv($('#txtRcdId').val()));
            //this.setState({
            //    ModalTxt: this.GetMultiLineCsv($('#txtRcdId').text.toString())
            //});
        }
    }

    GetMultiLineCsv(value) {
        //while (value.Contains(Environment.NewLine) || value.Contains('\r') || value.Contains('\n'))--->environment new line pending
        while (value.includes('\r') || value.includes('\n') || value.includes(';') || value.includes(' ')) {
            //value = value.Replace(Environment.NewLine, ",");
            value = value.replace('\r'.toString(), ",");
            value = value.replace('\n'.toString(), ",");
            value = value.replace(';'.toString(), ",");
            value = value.replace(' '.toString(), ",");
        }

        while (value.includes(",,")) {
            value = value.replace(",,", ",");
        }
        //s = s.Replace(",", "," + Environment.NewLine);
        return value;
    }

    InsideGeofencechange(event: React.FormEvent<HTMLSelectElement>) {
        var filters = this.state.Filters;
        var value: string = event.currentTarget.value;
        if (value == "---Select---")
            filters.SelectedGeofenceInside = null;
        else
            filters.SelectedGeofenceInside = value;
        this.setState({
            Filters: filters
        });
    }

    //Geofencechange(event: React.FormEvent<HTMLInputElement>) {
    //    var filters = this.state.Filters;
    //    var value: string = event.currentTarget.value;
    //    filters.SelectedGeofence = value;
    //    this.setState({
    //        Filters: filters
    //    });
    //}

    onSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            suggestionsFenceId: this.getFenceNameSuggestions(value)
        });
    };

    getFenceNameSuggestions(value) {
        var geofences = this.state.RcdGeofences;
        var targetValue = this.state.targetId;
        var inputValue = value.trim().toLowerCase();
        var inputLength = inputValue.length;
        return inputLength === 0 ? [] : geofences.filter(tag =>
            tag.toLowerCase().slice(0, inputLength) === inputValue
        );
    };

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestionsFenceId: []
        });
    };

    onChangeFenceId = (event, { newValue }) => {
        var filters = this.state.Filters;
        filters.SelectedGeofence = newValue;
        
        this.setState({
            Filters: filters,
            targetId: event.target.id
        });
    };

    renderSuggestion(suggestion) {
        return <span>{suggestion}</span>;
    }

    getSuggestionValue(suggestion) {
        return suggestion;
    }

    Countrychange(event: React.FormEvent<HTMLSelectElement>) {
        var filters = this.state.Filters;
        var value: string = event.currentTarget.value;
        if (value == "---Select---")
            filters.SelectedCountry = null;
        else
            filters.SelectedCountry = value;
        this.setState({
            Filters: filters
        });
    }
    AssetTypechange(event: React.FormEvent<HTMLSelectElement>) {
        var filters = this.state.Filters;
        var value: string = event.currentTarget.value;
        if (value == "---Select---")
            filters.SelectedAssetType = null;
        else
            filters.SelectedAssetType = value;
        this.setState({
            Filters: filters
        });
    }
    ReportingIntervalchange(event: React.FormEvent<HTMLSelectElement>) {
        var filters = this.state.Filters;
        var value: string = event.currentTarget.value;
        if (value == "---Select---")
            filters.SelectedInterval = null;
        else
            filters.SelectedInterval = value;
        this.setState({
            Filters: filters
        });
    }

    ICCIDChange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.Filters;
        var Value: string = event.currentTarget.value;
        filters.SelectedICCID = Value;
        this.setState({
            Filters: filters
        });
    }

    MSISDNChange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.Filters;
        var Value: string = event.currentTarget.value;
        filters.SelectedMSISDN = Value;
        this.setState({
            Filters: filters
        });
    }

    ClearFilter() {
        var filters = this.state.Filters;
        filters.SelectedRcd = "";
        filters.SelectedGeofenceInside = "";
        filters.SelectedGeofence = "";
        filters.SelectedCountry = "";
        filters.SelectedInterval = "";
        filters.SelectedICCID = "";
        filters.SelectedMSISDN = "";
        filters.SelectedAssetType = "";
        this.setState({
            Filters: filters
        });
    }

    isNullOrEmpty(value) {
        return value == null || value === "";
    }

    ApplyFilter() {
        //this.props.bindingRcdStatusGrid(this.state.Filters);
        this.state.Filters.AllRcds = "";
        if (!this.isNullOrEmpty(this.state.Filters.SelectedCountry) || !this.isNullOrEmpty(this.state.Filters.SelectedGeofence) || !this.isNullOrEmpty(this.state.Filters.SelectedGeofenceInside)
            || !this.isNullOrEmpty(this.state.Filters.SelectedInterval) || !this.isNullOrEmpty(this.state.Filters.SelectedRcd) || !this.isNullOrEmpty(this.state.Filters.SelectedICCID) || !this.isNullOrEmpty(this.state.Filters.SelectedMSISDN) || !this.isNullOrEmpty(this.state.Filters.SelectedAssetType)) {
            /*26262
            if (this.state.Filters.SelectedRcd.length <= 4000) {
                this.props.bindingRcdStatusGrid(this.state.Filters);
            }
            else {
                PopupWindow.showErrorMessage("Alert", "Maximum device search limit is 250.");
            }
            */
            this.props.bindingRcdStatusGrid(this.state.Filters);
        }
        else {
            this.state.Filters.AllRcds = "All Rcds";
            this.props.bindingRcdStatusGrid(this.state.Filters);            
        }     
    }

    componentDidMount() {
        var params = queryString.parse(window.location.search);
        if (!isNullOrUndefined(params.deviceId)) {            
            var filters = self.state.Filters;
            filters.SelectedRcd = params.deviceId;
            filters.AllRcds = "";
            self.props.bindingRcdStatusGrid(self.state.Filters);            
        }

        $(document).ready(function () {
            $('.advance-search').bind('keypress', function (e) {
                if (e.keyCode === 13) {
                    $('#button_search').trigger('click');
                }
            });
        });
    }

    BtnShowMultiLine() {
        $('#txtRcdId').attr('readonly');
        $('#txtRcdIds').val($('#txtRcdId').val());
        //this.setState({           
        //    ModalTxt: this.GetMultiLineCsv($('#txtRcdId').text.toString())
        // });
    }

    public render() {
         const { suggestionsFenceId } = this.state;

        const FenceIdListinputProps = {
            id: 'geofenceID',
            placeholder: 'Geofence ID',
            value: this.state.Filters.SelectedGeofence,
            onChange: this.onChangeFenceId.bind(this)
        };
        
        return <div className="advance-search page-controls-container">
            <form>
                <div className='row'>
                    <div className='col-md-2 col-lg-2 col-xl-1 text-md-end text-sm-start text-lg-end pe-0'>
                        <label className='col-form-label'>Device ID(s):</label>
                    </div>
                    <div className="col-md-4 col-lg-4 col-xl-8" >
                       
                            <textarea className="form-control texarea-55 "id="txtRcdIds" onChange={e => this.RCDIDschange(e)} placeholder='Device ID(s)' value={this.state.Filters.SelectedRcd} ></textarea>
                       
                    </div>
                    <div className="col-md-2 col-lg-2 col-xl-1 text-md-end text-sm-start text-lg-end pe-0" >
                        <label className='col-form-label'>Geofence Status:</label>
                    </div>
                    <div className="col-md-4 col-lg-4 col-xl-2" >
                        <select className='form-select' id='selectInsideGeofence' onChange={e => this.InsideGeofencechange(e)} value={this.state.Filters.SelectedGeofenceInside}>
                            <option>---Select---</option>
                            <option value="Yes">Inside Geofence Only</option>
                            <option value="No">Outside Geofence Only</option>
                        </select>
                    </div>
                </div>
                <div className="row mt-6">
                    <div className="col-md-2 col-lg-2 col-xl-1 text-md-end text-sm-start text-lg-end pe-0" >
                        <label className='col-form-label'>Geofence:</label>
                    </div>
                    <div className="col-md-4 col-lg-4 col-xl-2" >
                        <div>
                           <Autosuggest name="geofenceID" id="geofenceID"
                                suggestions={suggestionsFenceId}
                                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                                getSuggestionValue={this.getSuggestionValue}
                                renderSuggestion={this.renderSuggestion}
                                inputProps={FenceIdListinputProps}
                                highlightFirstSuggestion={true}
                            />
                        </div>
                    </div>
                    <div className="col-md-2 col-lg-2 col-xl-1 text-md-end text-sm-start text-lg-end pe-0" >
                        <label className='col-form-label'>Country:</label>
                    </div>
                    <div className="col-md-4 col-lg-4 col-xl-2" >

                        <select className='form-select' id='selectRefCountry' onChange={e => this.Countrychange(e)} value={this.state.Filters.SelectedCountry}>
                            <option>---Select---</option>
                            {
                                this.state.RcdCountry.map((item, index) =>
                                    <option key={index} value={item.CountryCd}>{item.CountryName}</option>
                                )}
                        </select>
                    </div>
                    <div className="col-md-2 col-lg-2 col-xl-1 text-md-end text-sm-start text-lg-end pe-0" >
                        <label className='col-form-label'>Reporting (min):</label>
                    </div>
                    <div className="col-md-4 col-lg-4 col-xl-2 " >
                        <select className='form-select' id='selectReportingInterval' onChange={e => this.ReportingIntervalchange(e)} value={this.state.Filters.SelectedInterval}>
                            <option>---Select---</option>
                            <option>10</option>
                            <option>15</option>
                            <option>30</option>
                            <option>60</option>
                            <option>120</option>
                            <option>240</option>
                        </select>
                    </div>
                    <div className="col-md-2 col-lg-2 col-xl-1 text-md-end text-sm-start text-lg-end pe-0" >
                        <label className='col-form-label'>ICCID:</label>
                    </div>
                    <div className="col-md-4 col-lg-4 col-xl-2 " >
                       
                            <input id='txtICCID' type='text' className='form-control' onChange={e => this.ICCIDChange(e)} placeholder='ICCID' value={this.state.Filters.SelectedICCID}/>
                       
                    </div>
                    
                </div>
                <div className="row mt-6" >
                    <div className="col-md-2 col-lg-2 col-xl-1 text-md-end text-sm-start text-lg-end pe-0" >
                        <label className='col-form-label'>MSISDN:</label>
                    </div>
                    <div className="col-md-4 col-lg-4 col-xl-2">
                       
                            <input id='txtMSIDN' type='text' className='form-control' onChange={e => this.MSISDNChange(e)} placeholder='MSISDN' value={this.state.Filters.SelectedMSISDN} />
                       
                    </div>
                    <div className="col-md-2 col-lg-2 col-xl-1 text-md-end text-sm-start text-lg-end pe-0" >
                        <label className='col-form-label'>Asset Type:</label>
                    </div>
                    <div className="col-md-4 col-lg-4 col-xl-2" >

                        <select className='form-select' id='selectAssetType' onChange={e => this.AssetTypechange(e)} value={this.state.Filters.SelectedAssetType}>
                            <option>---Select---</option>
                            {
                                this.state.AssetTypes.map((item, index) =>
                                    <option key={index} value={item.AssetTypeCD}>{item.AssetTypeDsc}</option>
                                )}
                        </select>
                    </div>
                    <div className="col-md-12 col-lg-12 col-xl-6">
                        <div className='float-end hstack gap-2'>
                            <button type='button' onClick={this.ClearFilter.bind(this)} className='btn btn-primary'>Clear</button>
                            <button type='button' id="button_search" onClick={this.ApplyFilter.bind(this)} className='btn btn-primary'>Search</button>                           
                        </div>
                    </div>
                </div>
            </form>
        </div>;
    }
}